module.exports = __webpack_public_path__ + "img/avatar-blank-integration.2da74c91.png";